import { createSlice } from "@reduxjs/toolkit";
import { fetchCollectionReport } from "./CollectionReportThunk";

const initialState = {
  list: [],
  details: [],
  groupListOfItems: [],
  groupWiseItems: [],
  categoryWiseItems: [],
  receipts: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "with item",
    fromDate: null,
    toDate: null,
    customerId: null,
    employeeId: null,
    itemId: null,
    groupId: null,
    categoryId: null,
    userId: null,
    locationId: null,
  },
};

const collectionReportSlice = createSlice({
  name: "collectionReport",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setGroupOfItems: (state, action) => {
      state.groupOfItems = action.payload;
    },
    resetDetails: (state) => {
      state.details = [];
      state.groupListOfItems = [];
      state.groupWiseItems = [];
      state.categoryWiseItems = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollectionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCollectionReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.sales || [];
        state.details = action.payload.details || [];
        state.groupWiseItems = action.payload.groupWiseItems || [];
        state.categoryWiseItems = action.payload.categoryWiseItems || [];
        state.receipts = action.payload.receipts || [];
      })
      .addCase(fetchCollectionReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters, setGroupOfItems, resetDetails } = collectionReportSlice.actions;
export default collectionReportSlice.reducer;